import * as P from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { getAspectCorrectedCoordinates as Z } from "../../utilities/uv.js";
import { grain as $ } from "../../helpers/grain.js";
import { distort as oo } from "../../helpers/distort.js";
import { glow as to } from "../../helpers/glow.js";
import { edgeMask as no } from "../../helpers/edgeMask.js";
const ao = {
  name: "ChromaticSoft4",
  collection: "chromatic-soft",
  tags: ["wave", "gradient"],
  props: {
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the wave effect."
    }
  },
  fragmentNode: (m) => {
    const {
      vec3: E,
      vec4: l,
      time: O,
      mix: n,
      sin: T,
      float: o,
      pow: s,
      uv: N,
      color: t
    } = P, _ = t("#7cfffb"), S = t("#3c5fea"), p = t("#73e0ea"), u = t("#228ddc"), C = t("#283cbf"), R = t("#369df1"), D = -0.5, G = 2, I = 0, L = 0, g = 0.2, A = 0.5, b = 9, F = 0.2, v = 0.05, w = 1, U = 0.6, Y = 0.5, x = 1, V = 1, c = N(), { correctedUV: W } = Z(), a = oo(c, g, A, b), h = s(_, o(2.2)), y = s(S, o(2.2)), B = s(p, o(2.2)), k = s(u, o(2.2)), H = n(
      h,
      y,
      c.x
    ), K = n(
      k,
      B,
      c.x
    ), Q = n(
      H,
      K,
      c.y
    ), d = a.x.sub(0.5), i = a.y.sub(0.5), X = i.mul(d).add(i.mul(d)).negate(), r = o(1).add(
      o(F).mul(
        T(
          X.add(O.mul(m.speed.uniform).mul(0.025)).div(v)
        )
      )
    ), z = no({
      inset: D,
      softness: G,
      offsetX: I,
      offsetY: L
    }), M = E(r, r, r).mul(z).mul(w), j = n(
      R,
      C,
      c.y
    ), f = $(U)(W), e = Q.mul(M).add(f), q = e.r.add(e.g).add(e.b), J = l(
      n(j.add(f), e, q),
      1
    );
    return to(J, _, Y, x, V);
  }
};
export {
  ao as componentDefinition,
  ao as default
};
